import React, { useState, useEffect } from "react";
import Grid from "components/UIComponents/Grid";
import { Column } from "devextreme-react/data-grid";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { taskSelected } from "features/service/updateRequestSlice";
import style from "./../Dashboard.module.scss";
import { Row } from "react-bootstrap";

const ReturnRequestsGrid = (props) => {
  const { t, i18n } = useTranslation("common");
  const history = useHistory();
  const [data, setData] = useState();
  const { user, clientProfiles } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    const getReturnRequestsList = async () => {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/PORTAL/CLIENTS/DASHBOARD/GET_CLIENT_DASHBOARD_RETURN_REQUESTS_LIST`,
        {
          Client_Profile_Id: clientProfiles?.Client_Profile_Id,
          PageIndex: "1",
          PageCount: "1000",
        },
        {
          headers: {
            Authorization: `Bearer ${user?.access_token}`,
          },
        }
      ).then(data => {
        setData(data.data.Data.Data)
        props.dataIsReady(false)
      })
    };
    getReturnRequestsList();
  }, []);

  let departmentName = "Department_Name_EN",
    serviceName = "Service_Name_EN",
    stepName = "Department_Service_Step_Name_EN",
    returnReason = "Request_Task_Title_Name_EN",
    areaName = "Area_Name_EN";

  if (i18n.language === "ar") {
    departmentName = "Department_Name_AR";
    serviceName = "Service_Name_AR";
    stepName = "Department_Service_Step_Name_AR";
    returnReason = "Request_Task_Title_Name_AR";
    areaName = "Area_Name_AR";
  }

  const handleEdit = (data) => {
    dispatch(taskSelected(data?.Task_Type_Id));
    history.push(`/update-request/${data?.Task_Type_Id}/${data?.Request_Id}/${data?.Request_Task_Id}`);
  };

  return (
    <>
      <Row className="justify-content-center">
        <p className={style.gridTitle}>{t("returned_requests")}</p>
      </Row>

      <Row>
        <Grid
          sourceData={data}
          addEnabled={false}
          editEnabled={true}
          deleteEnabled={false}
          viewEnabled={false}
          onEdit={({ data }) => handleEdit(data)}
        >
          <Column
            caption={t("request_no")}
            alignment="center"
            dataField="Request_No"
            dataType="string"
            width={170}
          />
          <Column
            caption={t("request_date")}
            alignment="center"
            dataField="Request_Date"
            dataType="date"
            width={130}
            format="yyyy-MM-dd"
          />
          <Column
            caption={t("service_name")}
            alignment="center"
            dataField={serviceName}
            dataType="string"
            width={140}
          />
          <Column
            caption={t("department_name")}
            alignment="center"
            dataField={departmentName}
            dataType="string"
            width={150}
            visible={false}
          />
          <Column
            caption={t("return_reason")}
            alignment="center"
            dataField={returnReason}
            dataType="string"
            width={150}
          />
          <Column
            caption={t("request_stage")}
            alignment="center"
            dataField={stepName}
            dataType="string"
            width={150}
          />
          <Column
            caption={t("owner")}
            alignment="center"
            dataField="Owner_Name"
            dataType="string"
            width={140}
          />
          <Column
            caption={t("plot_no")}
            alignment="center"
            dataField="Plot_No"
            dataType="string"
            width={140}
          />
          <Column
            caption={t("area_name")}
            alignment="center"
            dataField={areaName}
            dataType="string"
            width={140}
          />
          <Column
            caption={t("project_no")}
            alignment="center"
            dataField="Project_No"
            dataType="string"
            width={140}
          />
        </Grid>
      </Row>
    </>
  );
};

export default ReturnRequestsGrid;
